import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as ViewedReportIdsActions from './viewed-report-ids.actions';

export const viewedReportIdsFeatureKey = 'viewedReportIds';

export interface State {
  viewedReportIds: number[];
  isComplete: boolean;
}

export const initialState: State = {
  viewedReportIds: [],
  isComplete: false,
};

const viewedReportIdsReducer = createReducer(
  initialState.viewedReportIds,
  on(ViewedReportIdsActions.loadViewedReportIds, (state) => state),
  on(ViewedReportIdsActions.loadViewedReportIdsComplete, (state, action) => action.ids)
);

const completeReducer = createReducer(
  initialState.isComplete,
  on(ViewedReportIdsActions.loadViewedReportIds, () => false),
  on(ViewedReportIdsActions.loadViewedReportIdsComplete, () => true)
);

export const reducer: ActionReducerMap<State> = {
  viewedReportIds: viewedReportIdsReducer,
  isComplete: completeReducer,
};
